<template>
    <div>
        <div v-if="shareList && shareList.length > 0">
            <div v-for="(item, index) in shareList" :key="index"
                 style="padding-bottom: 20px;">
                <Wp_jd_share_model
                        :share-icon="item.icon"
                        :share-title="item.title"
                        :share-content="item.content"
                        :share-img="item.image"
                ></Wp_jd_share_model>
            </div>
        </div>
        <div v-else style="padding: 20px; text-align: center">
            <h2>{{tip}}</h2>
        </div>
    </div>
</template>

<script>
    import Wp_jd_share_model from "../custom/Wp_jd_share_model";
    export default {
        name: "Wp_mini_guide_share_page",
        components: {Wp_jd_share_model},

        data(){
            return{
                shareList:[],

                tip: "",

            }
        },

        created(){
            this.getShareDatas();
        },

        methods:{
            getShareDatas(){
                this.$getShareDatas(response=>{
                    if(response && response.data){
                        this.shareList = response.data;
                    }else{
                        this.tip = "功能升级中，敬请期待！";
                    }
                })
            }
        }
    }
</script>

<style scoped>

</style>